{
  "description": "Aus einem Durchlauf gespeichert.",
  "kinds": {"reply_turn": "Antwort", "step_turn": "Schritt"},
  "name": "Name des Prozessschemas",
  "nothing": "Dieser Durchlauf hat noch keinen abgeschlossenen Schritt und keine Antwort.",
  "open": "Prozessschema aus diesem Durchlauf erstellen",
  "pick": "Eintrag {{number}} verwenden",
  "save": "Prozessschema vorschlagen",
  "start": "Wie der Schritt startet",
  "starts": {
    "automatic": "Direkt nach dem vorigen Schritt",
    "on_request": "Wenn ihn jemand startet"
  },
  "subtitle": "Die gewählten Schritte und Antworten werden ein Prozessschema, das zum Review vorgeschlagen wird.",
  "title": "Prozessschema aus diesem Durchlauf erstellen"
}
